import { router } from '@inertiajs/react'

/**
 * Prop keys that drive Tasks dashboard instrument presence (task cards, NC cards,
 * per-instrument totals, pending flag). Post-action refresh and the fingerprint-triggered
 * poll reload share this one list (E50-S3 / REBUILD-433). dashboardFingerprint travels
 * with them so the page knows which fingerprint the rendered cards were built from.
 */
export const TASKS_DASHBOARD_RELOAD_ONLY = [
  'taskRecords',
  'hasPendingTasks',
  'taskCountsByInstrument',
  'ncRecords',
  'ncCountsByInstrument',
  'dashboardFingerprint',
] as const

/**
 * Stable poll options so `useStatusPoll` / `usePoll` are not restarted every render. The poll
 * asks only for the cheap fingerprint; the page reloads the card props when it changes.
 */
export const TASKS_DASHBOARD_STATUS_POLL_OPTIONS = {
  only: ['dashboardFingerprint'],
  onNetworkError: (): boolean => false,
}

/** Immediate partial reload after NC review so empty instruments leave without a full page reload. */
export const reloadTasksDashboardProps = (): void => {
  router.reload({ only: [...TASKS_DASHBOARD_RELOAD_ONLY] })
}
